import { render, staticRenderFns } from "./RunkanTransfer.vue?vue&type=template&id=9f4ae832&"
import script from "./RunkanTransfer.vue?vue&type=script&lang=js&"
export * from "./RunkanTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports